// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 제품 상세페이지 */
.product-section {
    max-width: 1200px;
    margin: 50px auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 50px;
    padding: 0 20px;
}

.product-section img {
    width: 400px;
    max-width: 100%;
    border: 1px solid #ccc;
}

.product-text h2 {
    font-size: 48px;
    margin-bottom: 15px;
}

.product-text h3 {
    font-size: 36px;
    margin-bottom: 15px;
    color: #555;
}

.product-text p {
    font-size: 20px;
    line-height: 1.6;
}

/* 모바일 반응형 */
@media (max-width: 768px) {
    .product-section {
        flex-direction: column;
        text-align: left;
        gap: 30px;
    }

    .product-section img {
        width: 200px;
    }

    .product-text h2 {
        font-size: 22px;
    }

    .product-text h3 {
        font-size: 18px;
    }

    .product-text p {
        font-size: 14px;
    }
}

.productchapter {
    display: flex;
    justify-content: center;
    /* 가로 가운데 */
    align-items: center;
    /* 세로 가운데 (부모 높이가 있을 때) */
    padding: 56px;
}

.productchapter img {
    max-width: 110%;
    /* 반응형 */
    height: auto;
}

@media (max-width: 768px) {
    .productchapter {
        padding: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./static/css/detail.css"],"names":[],"mappings":"AAAA,aAAa;AACb;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI;QACI,sBAAsB;QACtB,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* 제품 상세페이지 */\n.product-section {\n    max-width: 1200px;\n    margin: 50px auto;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    gap: 50px;\n    padding: 0 20px;\n}\n\n.product-section img {\n    width: 400px;\n    max-width: 100%;\n    border: 1px solid #ccc;\n}\n\n.product-text h2 {\n    font-size: 48px;\n    margin-bottom: 15px;\n}\n\n.product-text h3 {\n    font-size: 36px;\n    margin-bottom: 15px;\n    color: #555;\n}\n\n.product-text p {\n    font-size: 20px;\n    line-height: 1.6;\n}\n\n/* 모바일 반응형 */\n@media (max-width: 768px) {\n    .product-section {\n        flex-direction: column;\n        text-align: left;\n        gap: 30px;\n    }\n\n    .product-section img {\n        width: 200px;\n    }\n\n    .product-text h2 {\n        font-size: 22px;\n    }\n\n    .product-text h3 {\n        font-size: 18px;\n    }\n\n    .product-text p {\n        font-size: 14px;\n    }\n}\n\n.productchapter {\n    display: flex;\n    justify-content: center;\n    /* 가로 가운데 */\n    align-items: center;\n    /* 세로 가운데 (부모 높이가 있을 때) */\n    padding: 56px;\n}\n\n.productchapter img {\n    max-width: 110%;\n    /* 반응형 */\n    height: auto;\n}\n\n@media (max-width: 768px) {\n    .productchapter {\n        padding: 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
